// Generated by Claude Code
import { VendorsPage } from '#components/domain/operations/vendors/vendors-page.tsx'
import { PermissionGuard } from '#components/tools/permission-guard.tsx'
import { PermissionService } from '#core/entities/auth/roles/Permission.ts'
import { readAnyGroups } from '#core/entities/auth/roles/permission-gate-helpers.ts'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/$companyId/vendors/')({
  component: RouteComponent,
  staticData: {
    title: 'Vendors',
  },
})

function RouteComponent() {
  // Limited readers (any READ_LIMITED slot) may enter; the backend + limited-
  // access whitelists decide which properties they actually see.
  return (
    <PermissionGuard permissions={readAnyGroups(PermissionService.VENDORS)} redirectOnNotAuthorized>
      <VendorsPage />
    </PermissionGuard>
  )
}
